/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useMedia } from "use-media";

// フィールドの内容を配列で返す
export const writeField = (field_data, isWarp, isPC) => {


  const wordGrid = css`
    z-index: 1;
    outline: 1px solid blue;
  `;
  const trapGrid = css`
    z-index: 1;
    outline: 1px solid red;
    font-size: 0.9em;
    color: #555555;
  `;
  const gridStyle = css`
    z-index: 1;
  `;

  const grid_len = field_data.length;
  let draw_contents = [];
  // 一つ一つのグリッドの内容をdraw_contentsにpushする。
  for (let i = 0; i < grid_len; i++) {
    if (field_data[i].isNextGrid) {
      if (field_data[i].isWord) {
        if (isWarp) draw_contents.push(<div key={i} css={wordGrid} id="nextGrid" className="grid" value={i}><span>{field_data[i].player ? "👤" : field_data[i].checked ? field_data[i].checked : ""}</span>{field_data[i].contents}</div >);
        else draw_contents.push(<div key={i} css={wordGrid} id="nextGrid" value={i}><span>{field_data[i].player ? "👤" : field_data[i].checked ? field_data[i].checked : ""}</span>{field_data[i].contents}</div >);
      } else if (field_data[i].isTrap) {
        if (isWarp) draw_contents.push(<div key={i} id="nextGrid" className="grid" value={i} css={trapGrid}><span>{field_data[i].player ? "👤" : field_data[i].checked ? field_data[i].checked : ""}</span>{field_data[i].contents}</div >);
        else draw_contents.push(<div key={i} id="nextGrid" value={i} css={trapGrid}><span>{field_data[i].player ? "👤" : field_data[i].checked ? field_data[i].checked : ""}</span>{field_data[i].contents}</div >);
      } else {
        if (isWarp) draw_contents.push(<div key={i} id="nextGrid" className="grid" value={i}><span>{field_data[i].player ? "👤" : field_data[i].checked ? field_data[i].checked : ""}</span>{field_data[i].contents}</div >);
        else draw_contents.push(<div key={i} id="nextGrid" value={i}><span>{field_data[i].player ? "👤" : field_data[i].checked ? field_data[i].checked : ""}</span>{field_data[i].contents}</div >);
      }
    } else {
      if (field_data[i].isWord) {
        // プレイヤーがいるかどうか、いたかどうかを表示させる変数
        let gridStatus = "";
        if (field_data[i].player) gridStatus = "👤";
        else if (field_data[i].checked) gridStatus = field_data[i].checked;

        if (isWarp) draw_contents.push(<div key={i} css={wordGrid} className="grid" value={i}><span>{gridStatus}</span>{field_data[i].contents}</div >);
        else draw_contents.push(<div key={i} css={wordGrid} value={i}><span>{gridStatus}</span>{field_data[i].contents}</div >);
      } else if (field_data[i].isTrap) {
        // プレイヤーがいるかどうか、いたかどうかを表示させる変数
        let gridStatus = "";
        if (field_data[i].player) gridStatus = "👤";
        else if (field_data[i].checked) gridStatus = field_data[i].checked;

        if (i === 0) draw_contents.push(<div key={i} css={trapGrid}><span>{gridStatus}</span>{field_data[i].contents}</div >);
        else if (isWarp) draw_contents.push(<div key={i} value={i} className="grid" css={trapGrid}><span>{gridStatus}</span>{field_data[i].contents}</div >);
        else draw_contents.push(<div key={i} value={i} css={trapGrid}><span>{gridStatus}</span>{field_data[i].contents}</div >);
      } else {
        // プレイヤーがいるかどうか、いたかどうかを表示させる変数
        let gridStatus = "";
        if (field_data[i].player) gridStatus = "👤";
        else if (field_data[i].checked) gridStatus = field_data[i].checked;

        if (i === 0) draw_contents.push(<div key={i} ><span>{gridStatus}</span>{field_data[i].contents}</div >);
        else if (isWarp) draw_contents.push(<div key={i} value={i} className="grid" ><span>{gridStatus}</span>{field_data[i].contents}</div >);
        else draw_contents.push(<div key={i} value={i} css={gridStyle}><span>{gridStatus}</span>{field_data[i].contents}</div >);
      }
    }
  }
  return draw_contents;
}


export const countWords = (sentence, type) => {
  let cnt = 0;
  if (type === "isComplete") {
    for (let i = 1; i < 8; i++) {
      if (sentence[i].word_top && sentence[i].word_bottom) {
        cnt += 2
      } else if (sentence[i].word_top || sentence[i].word_bottom) {
        cnt += 1;
      }
    }
  } else {
    for (let i = 1; i < 8; i++) {
      if (sentence[i].word_top && sentence[i].word_bottom && (i == 1 || i == 3)) {
        cnt += 2
      } else if (sentence[i].word_top || sentence[i].word_bottom) {
        cnt += 1;
      }
    }
  }


  return cnt;
}
